import { render, staticRenderFns } from "./resume4.vue?vue&type=template&id=13ed80bc&scoped=true&"
import script from "./resume4.vue?vue&type=script&lang=js&"
export * from "./resume4.vue?vue&type=script&lang=js&"
import style0 from "./resume4.vue?vue&type=style&index=0&id=13ed80bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed80bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VSelect,VSimpleTable,VTextField})
